import { Typography } from 'antd';
import { isNil, noop } from 'lodash';
import React, { useEffect, useState } from 'react';
import AppSearchInput from './AppSearchInput';
import { useModalState } from '../hooks/useModalState';
import PaymentSearchModal from './PaymentSearchModal';

export type PaymentSelectedType = {
  payid?: number;
  payreference?: string;
  tpname?: string;
};

export type PaymentSelectProps = {
  onChange?: any;
  value?: PaymentSelectedType | any;
  clear?: boolean;
  onlyPayid?: boolean;
  ctref?: string;
};

const PaymentSelect = ({
  onChange = noop,
  value,
  clear,
  onlyPayid,
  ctref
}: PaymentSelectProps) => {
  const [Params, setParams] = useState<PaymentSelectedType>({
    payid: value?.payid,
    payreference: value?.payreference,
    tpname: value?.tpname
  });

  const { visible, close, open } = useModalState(false);
  const [onClear, setOnClear] = useState(false);

  const handleSelect = (item: any) => {
    onlyPayid ? onChange(item.payid) : onChange(item);
    setParams({
      payreference: item?.payreference,
      tpname: item.tpname,
      payid: item?.payid
    });
    setOnClear(true);
    close();
  };

  useEffect(() => {
    setOnClear(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    value = undefined;
    setParams({
      payreference: undefined,
      tpname: undefined,
      payid: undefined
    });
  }, [clear]);

  return (
    <>
      <AppSearchInput
        onSearch={() => {
          open();
          localStorage.removeItem('searchParams');
          localStorage.removeItem('searchParams_components');
        }}
        value={
          <Typography.Link>
            {onClear && !value?.payid
              ? Params?.payid && value !== 0 && value !== '' && !isNil(value)
                ? `${Params.payreference ?? ''}  -  ${Params.tpname ?? ''}`
                : 'Select an Payment'
              : value?.payid && value !== 0 && value !== '' && !isNil(value)
              ? `${value.payreference ?? ''}  -  ${value.tpname ?? ''}`
              : 'Select an Payment'}
          </Typography.Link>
        }
      />
      <PaymentSearchModal
        visible={visible}
        onCancel={close}
        setPayment={handleSelect}
        ctref={ctref}
      />
    </>
  );
};

export default PaymentSelect;
